export const RSUITE_PICKER_TYPE: symbol = Symbol.for('rsuite.picker');

export const RSUITE_PICKER_GROUP_KEY: unique symbol = Symbol.for('rsuite.picker_group_key');

export const RSUITE_TOASTER_ID = Symbol.for('rsuite.toaster_id');
